import type { BoxProps, SxProps, Theme } from '@mui/material'
import { Box, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'

import { COLORS } from '../../../constants'
import { unit } from '../../../utils'

type DividerWithLabelProps = PropsWithChildren & BoxProps & { component?: string; labelSx?: SxProps<Theme> }

export const DividerWithLabel: FC<DividerWithLabelProps> = ({ children, labelSx, ...props }) => {
  return (
    <Box bgcolor={COLORS.hiekka[500]} paddingY={unit(3.5)} paddingX={unit(7)} {...props}>
      <Typography variant='uppercaseS' sx={labelSx}>
        {children}
      </Typography>
    </Box>
  )
}
